// @flow
import { createContext } from 'react';

export const ClusterLinkingWorkloadContext = createContext({});
